module.exports = __webpack_public_path__ + "5ca9c72a6b5eff913902048b7b9e2241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tdgs-mn.png
// module id = 2015
// module chunks = 0